<script>
import utils from '@/utils/common';

import taskChangeApi from '@/api/taskChange';
import FormBlock from '@/components/FormBlock.vue';
import CommentForm from '@/components/CommentForm.vue';
import ProjectFileUploader from '@/components/ProjectFileUploader.vue';

export default {
  name: 'TaskDetailCommentAddForm',
  components: {
    ProjectFileUploader,
    CommentForm,
    FormBlock,
  },
  props: {
    task: Object,
  },
  data() {
    return {
      draft: null,
      additionalFiles: [],
    };
  },
  created() {
    taskChangeApi
      .fetchList({ task: this.task.id, itemsPerPage: 1, isDraft: true })
      .then((r) => { this.draft = this.fixProjectFiles(r.items[0]) ?? this.getTemplate(); });
  },
  computed: {
    saveDebounced() {
      return utils.debounce(this.saveRaw, 2000);
    },
  },
  methods: {
    fixProjectFiles(draft) {
      if (!draft) return null;

      return { ...draft, projectFiles: draft.projectFiles.map(f => f['@id']) };
    },
    getTemplate() {
      return {
        id: null,
        author: this.$store.state.auth.user,
        isDraft: true,
        isPosted: false,
        projectFiles: [],
        replyTo: null,
        info: { text: '' },
      };
    },
    extReply(comment) {
      this.draft.replyTo = comment;
      this.saveDebounced.deferred(false);
      this.$refs.form.$el.scrollIntoView({ behavior: 'smooth' });
    },
    onFilesUpdated(files) {
      this.draft = { ...this.draft, projectFiles: files };
      this.saveDebounced.deferred(false);
    },
    onCommentInput(data) {
      if (!data.info.text && !this.draft.id) return;
      this.saveDebounced.deferred(false);
    },
    saveRaw(isPublishing = false) {
      const { id, isPosted, projectFiles } = this.draft;
      const text = this.draft.info?.text ?? '';
      const createdAt = new Date();
      const replyTo = this.draft.replyTo?.['@id'] ?? null;
      const isDraft = !isPublishing;
      const formData = { task: this.task['@id'], isDraft, text, projectFiles, replyTo, createdAt }; // eslint-disable-line

      if (id) {
        taskChangeApi.update(id, formData, isPublishing).then(this.onSaved);
      } else if (!isPosted) {
        taskChangeApi.create(formData, isPublishing).then(this.onSaved);
        this.draft.isPosted = true;
      } else if (isPublishing) {
        setTimeout(() => { this.saveRaw(isPublishing); }, 100);
      }
    },
    onSaved(response) {
      if (response.isDraft) {
        this.draft.id = response.id;
        this.draft.isPosted = false;
        return;
      }

      const newComment = {
        ...response,
        createdAt: new Date(response.createdAt),
      };
      this.$emit('publish', newComment);
      this.draft = this.getTemplate();
    },
  },
};
</script>

<template lang="pug">
  FormBlock.task-comment-add-form(v-if="draft" ref="form" mobile)
    CommentForm(
      v-model="draft"
      @submit="saveDebounced.immediate(true)"
      @input="onCommentInput"
      @scrollToComment="$emit('scrollToComment', $event)"
      @dropFiles="additionalFiles = $event"
    )
      template(#files)
        ProjectFileUploader(:selected="draft.projectFiles" @select="onFilesUpdated" :filesToUpload="additionalFiles")
</template>

<style lang="scss">
  .task-comment-add-form {
    margin-bottom: 30px;
  }
</style>
